import { render, staticRenderFns } from "./AddClientDialog.vue?vue&type=template&id=38b9eef6"
import script from "./AddClientDialog.vue?vue&type=script&lang=js"
export * from "./AddClientDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports